import Micro from './Micro';
import MicroCombo from './MicroCombo';
import Mini from './Mini';

const TrustPilotEmbed = { Mini, Micro, MicroCombo };

export default TrustPilotEmbed;
